"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _formik = require("formik");

var _moment = _interopRequireDefault(require("moment"));

var _axios = _interopRequireDefault(require("axios"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _hooks = require("hooks");

var _schema = _interopRequireDefault(require("./schema"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var visibleStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  opacity: 1;\n  visibility: visible;\n"])));

var StyledPopup = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 11;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  background: ", ";\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.3s;\n\n  ", ";\n\n  @media (min-width: ", ") {\n    width: ", ";\n    margin: 0 auto;\n  }\n"])), function (p) {
  return p.theme.colorBetbarBackground || p.theme.colorCardBackground;
}, function (p) {
  return p.isVisible && visibleStyles;
}, function (p) {
  return p.theme.screenWidthMd;
}, function (p) {
  return p.theme.railWidth;
});

var StyledPopupTitle = _styledComponents.default.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.theme.colorText;
});

var StyledPopupContent = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0 1rem;\n"])));

var StyledHidden = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: ", ";\n"])), function (p) {
  return p.isHidden ? "none" : "block";
});

var Wrapper = function Wrapper(_ref) {
  var setAuth = _ref.setAuth,
      _ref$appearOnUsersCre = _ref.appearOnUsersCreatedBefore,
      appearOnUsersCreatedBefore = _ref$appearOnUsersCre === void 0 ? "2022-03-14" : _ref$appearOnUsersCre;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.auth;
  }),
      hasMissingProfileData = _useSelector.hasMissingProfileData,
      firstName = _useSelector.firstName,
      lastName = _useSelector.lastName,
      mobileNumber = _useSelector.mobileNumber,
      hasTotoAccount = _useSelector.hasTotoAccount,
      country = _useSelector.country,
      email = _useSelector.email,
      isLoggedIn = _useSelector.isLoggedIn;

  var _useTranslations = (0, _hooks.useTranslations)(),
      _useTranslations2 = _slicedToArray(_useTranslations, 1),
      translations = _useTranslations2[0];

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref2) {
      var setSubmitting, setValues, resetForm, params;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting = _ref2.setSubmitting, setValues = _ref2.setValues, resetForm = _ref2.resetForm;
              params = {
                firstName: values.firstName,
                lastName: values.lastName,
                mobileNumber: mobileNumber,
                address: {
                  country: values.country
                },
                hasTotoAccount: values.hasTotoAccount
              };
              _context.prev = 2;
              _context.next = 5;
              return _axios.default.put("/me", params);

            case 5:
              dispatch(setAuth({
                hasMissingProfileData: false
              }));
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              console.log("error updating profile");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));

    return function onSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var res, data, _data$data, _firstName, _lastName, _mobileNumber, _email, _hasTotoAccount, created, address, _country, userCreationDate, appCreationDate;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!isLoggedIn) {
                _context2.next = 11;
                break;
              }

              _context2.next = 3;
              return _axios.default.get("/me");

            case 3:
              res = _context2.sent;
              data = res.data;
              console.log("missing data popup", data === null || data === void 0 ? void 0 : data.data);
              _data$data = data === null || data === void 0 ? void 0 : data.data, _firstName = _data$data.firstName, _lastName = _data$data.lastName, _mobileNumber = _data$data.mobileNumber, _email = _data$data.email, _hasTotoAccount = _data$data.hasTotoAccount, created = _data$data.created, address = _data$data.address;
              _country = address.country;
              userCreationDate = (0, _moment.default)(created);
              appCreationDate = (0, _moment.default)(appearOnUsersCreatedBefore);

              if (userCreationDate.isBefore(appCreationDate) && (!_firstName || !_lastName || !_mobileNumber || !_email)) {
                dispatch(setAuth({
                  hasMissingProfileData: true,
                  country: _country,
                  firstName: _firstName,
                  lastName: _lastName,
                  mobileNumber: _mobileNumber,
                  email: _email,
                  hasTotoAccount: _hasTotoAccount
                }));
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [isLoggedIn]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Overlay, {
      zIndex: "10",
      isVisible: hasMissingProfileData
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPopup, {
      isVisible: hasMissingProfileData,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPopupTitle, {
        children: translations.welcomeBack
      }), hasMissingProfileData && /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Formik, {
        initialValues: {
          firstName: firstName,
          lastName: lastName,
          country: country,
          email: email,
          mobileNumber: mobileNumber,
          hasTotoAccount: hasTotoAccount
        },
        validateOnMount: true,
        validationSchema: (0, _schema.default)(translations, true),
        onSubmit: onSubmit,
        children: function children(_ref5) {
          var isValid = _ref5.isValid,
              values = _ref5.values,
              errors = _ref5.errors,
              dirty = _ref5.dirty,
              handleChange = _ref5.handleChange,
              isSubmitting = _ref5.isSubmitting;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_formik.Form, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPopupContent, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.TitleStack, {
                title: translations.personalDetails,
                subtitle: translations.personalDetailsSubtitle
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
                  isSmallerText: true,
                  alignItems: "center",
                  checked: values.hasTotoAccount,
                  label: translations.hasTotoAccountCheckbox,
                  onChange: function onChange(e) {
                    window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
                      AppName: process.env.REACT_APP_TITLE
                    }));
                    handleChange(e);
                  },
                  name: "hasTotoAccount"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHidden, {
                isHidden: firstName,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                    name: "firstName",
                    placeholder: translations.firstName,
                    value: values.firstName,
                    isRequired: true,
                    isError: dirty && errors.firstName,
                    onChange: handleChange
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                  isVisible: errors.firstName,
                  children: errors.firstName
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHidden, {
                isHidden: lastName,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                    name: "lastName",
                    placeholder: translations.lastName,
                    value: values.lastName,
                    isRequired: true,
                    isError: errors.lastName,
                    onChange: handleChange
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                  isVisible: errors.lastName,
                  children: errors.lastName
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHidden, {
                isHidden: email,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                    name: "email",
                    placeholder: translations.email,
                    value: values.email,
                    isRequired: true,
                    isError: errors.email,
                    onChange: handleChange
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                  isVisible: errors.email,
                  children: errors.email
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHidden, {
                isHidden: mobileNumber,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                    name: "mobileNumber",
                    placeholder: translations.mobileNumber,
                    value: values.mobileNumber,
                    isRequired: true,
                    isError: errors.mobileNumber,
                    onChange: handleChange
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                  isVisible: errors.mobileNumber,
                  children: errors.mobileNumber
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHidden, {
                isHidden: country,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormTextbox, {
                    name: "country",
                    placeholder: translations.country,
                    value: values.country,
                    isRequired: true,
                    isError: errors.country,
                    onChange: handleChange
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRowMessage, {
                  isVisible: errors.country,
                  children: errors.country
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
                isLoading: isSubmitting,
                style: {
                  marginBottom: "1rem"
                },
                type: "submit",
                disabled: !isValid || !dirty,
                children: translations.saveChanges
              })]
            })
          });
        }
      })]
    })]
  });
};

var _default = Wrapper;
exports.default = _default;